module.exports = __webpack_public_path__ + "img/img_sq.fa92a834.png";